import { analytics } from '../firebase';
import { logEvent } from 'firebase/analytics';

// Analytics event tracking functions
export const trackEvent = (eventName: string, parameters?: any) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
  }
};

// Common events
export const trackPageView = (pageName: string) => {
  trackEvent('page_view', {
    page_title: pageName,
    page_location: window.location.href
  });
};

export const trackButtonClick = (buttonName: string, location?: string) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location || 'unknown'
  });
};

export const trackFormSubmit = (formName: string) => {
  trackEvent('form_submit', {
    form_name: formName
  });
};

export const trackSignUp = (method: string) => {
  trackEvent('sign_up', {
    method: method
  });
};

export const trackLogin = (method: string) => {
  trackEvent('login', {
    method: method
  });
};

export const trackPurchase = (value: number, currency: string = 'USD') => {
  trackEvent('purchase', {
    value: value,
    currency: currency
  });
};

export const trackViewItem = (itemName: string, category?: string) => {
  trackEvent('view_item', {
    item_name: itemName,
    item_category: category || 'general'
  });
};
